import React from 'react';

import { IconColors, SimpleIcon } from './icon-utils';
import type { SimpleIconInterface } from './icon-utils';

export function MagnifyingGlassIcon({
  className,
  fill = IconColors.DarkGrey,
  height = 14,
  width = 14,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height}
      viewBoxDimensions="0 0 14 14"
      width={width}
    >
      <path
        d="M3.50928 0.460449C6.4379 -0.784184 9.82125 0.580682 11.0659 3.50928C11.9237 5.52781 11.5404 7.76151 10.2612 9.36279L13.812 12.9136C14.0603 13.162 14.0602 13.5645 13.812 13.813C13.5635 14.0614 13.1601 14.0615 12.9116 13.813L9.36084 10.2612C8.96014 10.5814 8.51125 10.8555 8.01611 11.0659C5.08756 12.3103 1.70504 10.9446 0.460449 8.01611C-0.783987 5.08756 0.580777 1.70508 3.50928 0.460449ZM9.89404 4.00732C8.92433 1.72559 6.2891 0.661841 4.00732 1.63135C1.72555 2.60116 0.6616 5.23723 1.63135 7.51904C2.60127 9.80051 5.23738 10.8636 7.51904 9.89404C9.80044 8.92416 10.8635 6.28893 9.89404 4.00732Z"
        fill={fill}
      />
    </SimpleIcon>
  );
}
